import { render } from "./MunicipioBusinesses.vue?vue&type=template&id=7efc290e"
import script from "./MunicipioBusinesses.vue?vue&type=script&lang=js"
export * from "./MunicipioBusinesses.vue?vue&type=script&lang=js"

import "./MunicipioBusinesses.vue?vue&type=style&index=0&id=7efc290e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__